import styles from './PanelSidebarEditor.module.css'

function PanelSidebarEditor({ children, title }) {
  return (
    <div className={styles.card}>
      <div className={styles.container}>{children}</div>
    </div>
  )
}

export default PanelSidebarEditor
